import React, { SyntheticEvent, useState } from 'react'
import { ReactComponent as IcoDM } from 'assets/icons/Logo.svg'
import style from './Auth.module.css'
import { Client, User } from 'types'
import axiosClient from 'axios-client'
import { Navigate, useNavigate } from 'react-router-dom'

//import { useStateContext } from 'src/context/ContextProvider'
//import axiosClient from 'src/axios-client'

const Register = () => {
  const [newUser, setNewUser] = useState<User>({} as User)
  const [message, setMessage] = useState('Please fill in your information to sign up')
  const navigate = useNavigate()

  const onSubmit = (ev: SyntheticEvent) => {
    ev.preventDefault()

    axiosClient
      .post('/register', newUser)
      .then(() => {
        // On successful response (status code 2xx), update the user and token state with the data received from the server
        navigate('/congratulations')
      })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: 'auto' }}>
      <IcoDM className={`${style.logo}`} />
      <div className={`${style.h1Text}`}>Welcome to Digest Web application</div>
      <div className={`${style.h2Text}`}>
        Take charge of Your Business Success with Digest App Manager
      </div>
      <div
        className={`${style.message}`}
        style={{ display: message === '' ? 'none' : '' }}
      >
        {message}
      </div>

      <form className={`${style.form}`}>
        <div className={`${style.row}`}>
          <input
            type="text"
            placeholder="First name"
            className={`${style.input}`}
            value={newUser?.firstname}
            onChange={ev => setNewUser({ ...newUser, firstname: ev.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Last name"
            className={`${style.input}`}
            value={newUser?.lastname}
            onChange={ev => setNewUser({ ...newUser, lastname: ev.target.value })}
            required
          />
        </div>

        <input
          type="email"
          placeholder="Email"
          className={`${style.input}`}
          value={newUser?.email}
          onChange={ev => setNewUser({ ...newUser, email: ev.target.value })}
          required
        />

        <input
          type="text"
          placeholder="Company name"
          className={`${style.input}`}
          value={newUser.client?.name}
          onChange={ev =>
            setNewUser({
              ...newUser,
              client: { ...newUser.client, name: ev.target.value } as Client,
            })
          }
          required
        />
        <input
          type="email"
          placeholder="Company email"
          className={`${style.input}`}
          value={newUser.client?.email}
          onChange={ev =>
            setNewUser({
              ...newUser,
              client: { ...newUser.client, email: ev.target.value } as Client,
            })
          }
          required
        />

        <input
          type="submit"
          value="Submit"
          className={`${style.submit}`}
          onClick={onSubmit}
        />
      </form>
    </div>
  )
}

export default Register
